import React from 'react';
import Link from '../../Link';
import PropTypes from 'prop-types';

const SadEmoji = ({
    setHappyEmojiClicked,
    setNeutralEmojiClicked,
    setSadEmojiClicked,
    setRatingId,
    sadEmojiClicked,
    dataId,
}) => {
    const sadEmojiHandler = () => {
        setSadEmojiClicked(!sadEmojiClicked);
        setNeutralEmojiClicked(true);
        setHappyEmojiClicked(true);
        setRatingId(sadEmojiClicked ? dataId[2].id : '');
    };
    return (
        <Link normal onClick={() => sadEmojiHandler()}>
            {sadEmojiClicked ? (
                <img
                    className="emoji_rating"
                    src={require('../../../assets/Bad_outline.svg')}
                    alt="sad_outline"
                />
            ) : (
                <img
                    className="emoji_rating"
                    src={require('../../../assets/Bad_filled.svg')}
                    alt="sad_filled"
                />
            )}
        </Link>
    );
};

SadEmoji.propTypes = {
    setHappyEmojiClicked: PropTypes.func.isRequired,
    setNeutralEmojiClicked: PropTypes.func.isRequired,
    setSadEmojiClicked: PropTypes.func.isRequired,
    setRatingId: PropTypes.func.isRequired,
    sadEmojiClicked: PropTypes.bool.isRequired,
    dataId: PropTypes.array.isRequired,
};

export default SadEmoji;
